/**
 * 该文件用于自动注册某个文件夹下的组件为全局组件
 * */
import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
const context = require.context(
  '@/components/Auto', // 要自动引入的组件目录的路径
  true, // 是否查询其子目录
  /\.vue/ // 匹配基础组件文件名的正则表达式
)

context.keys().forEach((fileName) => {
  const reqCom = context(fileName)

  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    reqCom.default || reqCom
  )
})
